// Konuşulan cümleyi alıp, tahsilat formundaki alanları otomatik tahmin eder
export const parseCollectionVoice = (text, existingSellers = []) => {
    let result = {};
    const tr = text.toLowerCase();

    // 1. TUTAR: Cümle içindeki ardışık rakamları bul (örn: 500, 1500.50)
    const amountMatch = text.match(/\b\d+(\.\d+)?\b/);
    if (amountMatch) {
        result.amount = amountMatch[0];
    }

    // 2. DÖVİZ CİNSİ
    if (tr.includes('dolar') || tr.includes('usd')) result.currency = 'USD';
    else if (tr.includes('euro') || tr.includes('avro') || tr.includes('eur')) result.currency = 'EUR';
    else if (tr.includes('lira') || tr.includes('tl') || tr.includes('türk lirası')) result.currency = 'TRY';
    else if (tr.includes('ruble') || tr.includes('rub')) result.currency = 'RUB';

    // 3. KURUM
    if (tr.includes('iş bankası') || tr.includes('is bankasi')) result.institution = 'İş Bankası';
    else if (tr.includes('garanti')) result.institution = 'Garanti BBVA';
    else if (tr.includes('ziraat')) result.institution = 'Ziraat Bankası';
    else if (tr.includes('korona') || tr.includes('koro na') || tr.includes('koronapay')) result.institution = 'Korona Pay';
    else if (tr.includes('vakıf')) result.institution = 'Vakıfbank';
    else if (tr.includes('yapı kredi') || tr.includes('yapi kredi')) result.institution = 'Yapı Kredi';
    else if (tr.includes('akbank')) result.institution = 'Akbank';
    else if (tr.includes('elden') || tr.includes('nakit') || tr.includes('kasa')) result.institution = 'Elden / Nakit';

    // 4. SATICI BULMA (Cümle içerisinde Admin'in listesinde kayıtlı satıcılardan biri geçerse kapar)
    if (existingSellers && existingSellers.length > 0) {
        for (let s of existingSellers) {
            if (tr.includes(s.name.toLowerCase())) {
                result.seller = s.name;
                break; // İlk eşleşeni al
            }
        }
    }

    // 5. ALICI BULMA (Örn: "Bilal'den Salih'e", "Alıcı Salih", "Salih'e gönderildi")
    // "X'den Y'ye" formatını yakalamak için:
    // "-den", "-dan", "ten", "tan" kelimesinden sonra gelen ilk kelime grubunu (isim soyisim) ve
    // sonrasındaki "-e", "-a", "-ye", "-ya" ekini yakala
    const fromToMatch = text.match(/(?:den|dan|ten|tan)\s+([a-zA-ZğüşıöçĞÜŞİÖÇ\s]+?)[’']?(?:e|a|ye|ya)\b/i);

    // Ses tanıma bazen "-e" ekinden sonra hemen boşluk bırakmayıp kelimeleri birleştirebilir veya
    // cümlenin devamında o ismi yakalayabilmek için kelime sınırlarına \b bakarız.

    if (fromToMatch && fromToMatch[1]) {
        let rawBuyer = fromToMatch[1].trim();
        // Cümlede "salih'e korona peyniri" dendiğinde "salih" i yakalamasını istiyoruz.
        // Eğer isim kısmı çok uzunsa (aradaki kelimeleri de yutuyorsa) sadece ilk iki kelimeyi al:
        let words = rawBuyer.split(/\s+/);
        if (words.length > 2) rawBuyer = words.slice(0, 2).join(' ');

        result.buyer = rawBuyer.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
    } else {
        // "alıcı [İsim]" formatını yakalamak için
        const buyerMatch = text.match(/alıcı(?:sı)?\s+([a-zA-ZğüşıöçĞÜŞİÖÇ\s]+?)(?:\s+(?:[0-9]|korona|iş|garanti|ziraat|vakıf|yapı|akbank|dolar|euro|tl|avro|lira|elden|nakit|peyniri|pay|$))/i);
        if (buyerMatch && buyerMatch[1]) {
            let rawBuyer = buyerMatch[1].trim();
            let words = rawBuyer.split(/\s+/);
            if (words.length > 2) rawBuyer = words.slice(0, 2).join(' ');

            result.buyer = rawBuyer.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
        }
    }

    return result;
};


// Konuşulan cümleyi alıp, Kargo (Sevkiyat) formundaki alanları otomatik tahmin eder
export const parseShipmentVoice = (text, existingSellers = []) => {
    let result = {};
    const tr = text.toLowerCase();

    // 1. ÇUVAL SAYISI (Örn: "5 çuval", "on paket" -> rakam yoksa alamayabilir ama "5" i alır)
    const sackMatch = text.match(/\b(\d+)\s*(?:çuval|paket|koli|adet)/i) || text.match(/\b\d+\b/);
    if (sackMatch) {
        // [1] inci grup rakamdır (varsa), yoksa [0] direkt eşleşen rakamdır
        result.sackCount = sackMatch[1] || sackMatch[0];
    }

    // 2. GÖNDERİM YOLU
    if (tr.includes('yurtiçi') || tr.includes('yurt içi')) result.route = 'Yurtiçi Kargo';
    else if (tr.includes('sürat')) result.route = 'Sürat Kargo';
    else if (tr.includes('mng')) result.route = 'MNG Kargo';
    else if (tr.includes('aras')) result.route = 'Aras Kargo';
    else if (tr.includes('ptt')) result.route = 'PTT Kargo';
    else if (tr.includes('dhl') || tr.includes('yurt dışı') || tr.includes('yurtdışı')) result.route = 'DHL / Yurtdışı';
    else if (tr.includes('ambar')) result.route = 'Ambar';

    // 3. ÖDEME YÖNTEMİ
    if (tr.includes('biz') || tr.includes('gönderici')) result.payer = 'Biz (Gönderici)';
    else if (tr.includes('alıcı') || tr.includes('karşı ödemeli')) result.payer = 'Alıcı';

    // 4. ŞEHİR (Türkiye Illerini Taramaca)
    const cities = ["adana", "adıyaman", "afyon", "ağrı", "amasya", "ankara", "antalya", "artvin", "aydın", "balıkesir", "bilecik", "bingöl", "bitlis", "bolu", "burdur", "bursa", "çanakkale", "çankırı", "çorum", "denizli", "diyarbakır", "edirne", "elazığ", "erzincan", "erzurum", "eskişehir", "gaziantep", "giresun", "gümüşhane", "hakkari", "hatay", "ısparta", "mersin", "istanbul", "izmir", "kars", "kastamonu", "kayseri", "kırklareli", "kırşehir", "kocaeli", "konya", "kütahya", "malatya", "manisa", "kahramanmaraş", "mardin", "muğla", "muş", "nevşehir", "niğde", "ordu", "rize", "sakarya", "samsun", "siirt", "sinop", "sivas", "tekirdağ", "tokat", "trabzon", "tunceli", "şanlıurfa", "uşak", "van", "yozgat", "zonguldak", "aksaray", "bayburt", "karaman", "kırıkkale", "batman", "şırnak", "bartın", "ardahan", "ığdır", "yalova", "karabük", "kilis", "osmaniye", "düzce"];
    for (let c of cities) {
        if (tr.includes(c)) {
            // İlk harfi büyük yap
            result.city = c.charAt(0).toUpperCase() + c.slice(1);
            break;
        }
    }

    // 5. SATICI BULMA
    if (existingSellers && existingSellers.length > 0) {
        for (let s of existingSellers) {
            if (tr.includes(s.name.toLowerCase())) {
                result.seller = s.name;
                // Alıcı adını bulmak için satıcı adından sonrasını kullanabiliriz
                // Örn: "Satıcı Onur, Alıcı Ahmet, 5 çuval Ankara"
                break;
            }
        }
    }

    // 6. ALICI BULMA (Basit bir heuristic: "alıcı" kelimesinden sonraki 1-2 kelimeyi al)
    // Örn: "alıcı ahmet yılmaz" -> "Ahmet Yılmaz"
    // Ya da "ahmet yılmaz'a gönderilecek"
    const buyerMatch = text.match(/alıcı(?:sı)?\s+([a-zA-ZğüşıöçĞÜŞİÖÇ\s]+?)(?:\s+(?:[0-9]|çuval|paket|koli|adet|yurtiçi|sürat|mng|aras|ptt|dhl|ambar|biz|gönderici|karşı|$))/i);

    if (buyerMatch && buyerMatch[1]) {
        // Alıcı adını temizle (fazla boşlukları at)
        let rawBuyer = buyerMatch[1].trim();
        // Eğer çok uzunsa (muhtemelen başka cümleleri de kapmıştır), ilk 2-3 kelimeyi al
        let words = rawBuyer.split(/\s+/);
        if (words.length > 3) {
            rawBuyer = words.slice(0, 3).join(' ');
        }

        // İlk harfleri büyük yap
        result.buyer = rawBuyer.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
    } else {
        // "alıcı" kelimesi geçmiyorsa ama cümlede isme benzeyen bir şeyler varsa (çok zor), 
        // şimdilik sadece "alıcı xyz" formatını destekleyelim.
    }

    return result;
};
